import { createPublicClient } from '../../../../app/infrastructure/http/apiClient';
import type { AboutUsBody } from '../../application/types';

type AboutUsEnvelope = {
  data?: {
    body?: Record<string, string>;
  };
};

export async function fetchAboutUs(): Promise<AboutUsBody> {
  const response = await createPublicClient().get<AboutUsEnvelope>(
    '/public/about-us',
  );
  const body = response.data?.data?.body ?? {};
  return {
    ua: body.ua ?? '',
    en: body.en ?? '',
  };
}
